import { createReducer } from '@reduxjs/toolkit';
import { IModerationSearchState as State, ModerationSearchType } from '../types';
import * as actions from '../actions';

const {
  resetAllFilters,
  changePageFilters,
  searchModerationItemsSuccess,
  searchModerationItemsFailure,
  findUserSuggestionsSuccess,
  findUserSuggestionsFailure,
  clearUserSuggestions
} = actions;

const initialState: State = {
  searchType: ModerationSearchType.USERNAME,
  searchValue: '',
  suggestions: [],
  error: null
};

const searchReducer = createReducer(initialState, {
  [searchModerationItemsSuccess.type]: (state: State, { payload: { searchType, searchValue } }) => {
    state.searchType = searchType;
    state.searchValue = searchValue;
    state.suggestions = [];
  },
  [searchModerationItemsFailure.type]: (
    state: State,
    { payload: { searchType, searchValue, error } }
  ) => {
    state.suggestions = [];
    state.error = error;
  },
  [resetAllFilters.type]: clearAllSearchSettings,
  [changePageFilters.type]: (state, { payload: { search = {} } }) => {
    state.searchType = search.searchType || initialState.searchType;
    state.searchValue = search.searchValue || initialState.searchValue;
    state.suggestions = [];
    state.error = null;
  },
  [findUserSuggestionsSuccess.type]: findUserReducer,
  [findUserSuggestionsFailure.type]: findUserReducer,
  [clearUserSuggestions.type]: state => {
    state.suggestions = [];
    state.error = null;
  }
});

function clearAllSearchSettings(state: State) {
  state.searchType = initialState.searchType;
  state.searchValue = initialState.searchValue;
  state.suggestions = initialState.suggestions;
  state.error = null;
}

function findUserReducer(state: State, { payload: { suggestions } = { suggestions: [] } }) {
  state.suggestions = suggestions || [];
  state.error = null;
}

export { searchReducer };
